"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListingReview_classNames_1 = require("./ListingReview.classNames");
var ListingReview_styles_1 = require("./ListingReview.styles");
var Rating_1 = require("office-ui-fabric-react/lib/Rating");
var MomentDataUtils_1 = require("@twii/core/lib/MomentDataUtils");
var ListingReview = /** @class */ (function (_super) {
    __extends(ListingReview, _super);
    function ListingReview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingReview.prototype.render = function () {
        var classNames = ListingReview_classNames_1.getClassNames(ListingReview_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        var review = this.props.review;
        var author = review.author;
        return (React.createElement("div", { className: classNames.root },
            React.createElement("div", { className: classNames.header },
                React.createElement("div", { className: classNames.author }, author.display_name),
                React.createElement("div", { className: classNames.date }, MomentDataUtils_1.timestampIO(review.edited_date || review.created_date)),
                React.createElement(Rating_1.Rating, { className: classNames.rating, rating: review.rate, readOnly: true })),
            React.createElement("div", { className: classNames.body },
                React.createElement("div", { className: classNames.content }, review.text))));
    };
    return ListingReview;
}(React.Component));
exports.ListingReview = ListingReview;
